import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface Project {
  id: number;
  title: string;
  description: string;
  status: string;
  dueDate: string;
  progress: number;
}
interface ProjectModalProps {
  project: Project | null;
  onClose: () => void;
  onSave: (project: Project | Omit<Project, 'id'>) => void;
}
export function ProjectModal({
  project,
  onClose,
  onSave
}: ProjectModalProps) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    status: 'Planifié',
    dueDate: '',
    progress: 0
  });
  useEffect(() => {
    if (project) {
      setFormData({
        title: project.title,
        description: project.description,
        status: project.status,
        dueDate: project.dueDate,
        progress: project.progress
      });
    }
  }, [project]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (project) {
      onSave({
        ...formData,
        id: project.id
      });
    } else {
      onSave(formData);
    }
  };
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose} data-id="element-120">
      <div className="bg-white dark:bg-gray-800 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-121">
        <div className="sticky top-0 bg-white dark:bg-gray-800 border-b p-6 flex justify-between items-center" data-id="element-122">
          <h2 className="text-2xl font-semibold" data-id="element-123">
            {project ? 'Modifier le projet' : 'Nouveau projet'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-124">
            <X size={24} data-id="element-125" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-126">
          <div data-id="element-127">
            <label className="block text-sm font-medium mb-2" data-id="element-128">
              Titre du projet *
            </label>
            <input type="text" required value={formData.title} onChange={e => setFormData({
            ...formData,
            title: e.target.value
          })} className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary" placeholder="Entrez le titre du projet" data-id="element-129" />
          </div>
          <div data-id="element-130">
            <label className="block text-sm font-medium mb-2" data-id="element-131">
              Description *
            </label>
            <textarea required value={formData.description} onChange={e => setFormData({
            ...formData,
            description: e.target.value
          })} className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary h-24 resize-none" placeholder="Décrivez le projet" data-id="element-132" />
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-133">
            <div data-id="element-134">
              <label className="block text-sm font-medium mb-2" data-id="element-135">Statut *</label>
              <select value={formData.status} onChange={e => setFormData({
              ...formData,
              status: e.target.value
            })} className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary" data-id="element-136">
                <option value="Planifié" data-id="element-137">Planifié</option>
                <option value="En cours" data-id="element-138">En cours</option>
                <option value="Terminé" data-id="element-139">Terminé</option>
              </select>
            </div>
            <div data-id="element-140">
              <label className="block text-sm font-medium mb-2" data-id="element-141">
                Date d'échéance *
              </label>
              <input type="date" required value={formData.dueDate} onChange={e => setFormData({
              ...formData,
              dueDate: e.target.value
            })} className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary" data-id="element-142" />
            </div>
          </div>
          <div data-id="element-143">
            <label className="block text-sm font-medium mb-2" data-id="element-144">
              Progression: {formData.progress}%
            </label>
            <input type="range" min="0" max="100" value={formData.progress} onChange={e => setFormData({
            ...formData,
            progress: parseInt(e.target.value)
          })} className="w-full" data-id="element-145" />
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mt-2" data-id="element-146">
              <div className="bg-blue-600 h-2 rounded-full transition-all" style={{
              width: `${formData.progress}%`
            }} data-id="element-147"></div>
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t" data-id="element-148">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-149">
              Annuler
            </button>
            <button type="submit" className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors" data-id="element-150">
              {project ? 'Enregistrer' : 'Créer le projet'}
            </button>
          </div>
        </form>
      </div>
    </div>;
}